.container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.chartTitleWrapper {
  display: flex;
  justify-content: space-between;
}
